import { FC, useCallback } from 'react';
import useStateDebounceChange from 'src/common/hooks/useStateDebounceChange';
import CaptainFilter, { CaptainFilterProps } from 'src/search/components/CaptainFilter';

type FilterModalCaptainProps = Pick<CaptainFilterProps, 'value' | 'onChange'>;

const FilterModalCaptain: FC<FilterModalCaptainProps> = ({ value: externalValue, onChange }) => {
  const [value, setValue] = useStateDebounceChange(onChange, externalValue);
  const onClear = useCallback(() => setValue(null), [setValue]);

  return (
    <CaptainFilter
      value={value}
      onChange={setValue}
      onClear={onClear}
    />
  );
};

export default FilterModalCaptain;
